
<div class="v-flex">
    <div class="mr-2">
        <i class="fa fa-align-justify handle primary--text"></i>
    </div>
    <f-phone-type
        v-model = "type"
        class   = "mr-2"
        @input  = "onChanged"
    />
    <f-country
        v-model = "country"
        @input  = "onChanged"
    />
    <v-text-field
        v-model        = "number"
        class          = "ml-2"
        @input         = "onChanged"
        label          = "Telefonnummer"
        autocomplete   = "off"
        autocorrect    = "off"
        autocapitalize = "off"
        spellcheck     = "false"
    />
    <div class="mr-1" style="padding-top: 18px">
        <a @click="onCopyNumber">
            <v-icon color="primary" size="18" class="toolbar-button">
                mdi-content-copy
            </v-icon>
        </a>
    </div>
    <div style="padding-top: 19px">
        <a @click="onDelete">
            <v-icon color="error" size="22" class="toolbar-button">
                mdi-close
            </v-icon>
        </a>
    </div>
</div>
